<template>
  <v-card :color="user.avatar ? 'white' : 'primary'" class="my-4 custom-avatar">
    <v-img
      style="border-radius:50%"
      v-if="user.avatar"
      :src="user.avatar"
      max-width="123px"
      height="123px"
      max-height="123px"
    >
      <template v-slot:placeholder>
        <v-row class="primary fill-height ma-0" align="center" justify="center">
          <v-progress-circular
            indeterminate
            color="grey lighten-5"
          ></v-progress-circular>
        </v-row>
      </template>
    </v-img>

    <span v-else class="white--text display-1">{{ initials }}</span>
    <v-btn
      @click.stop="dialog = true"
      class="mr-n5 mb-4"
      small
      fab
      absolute=""
      bottom=""
      right=""
      ><v-icon color="#767676"> mdi-camera</v-icon></v-btn
    >
    <modal :user="user" @CloseModal="dialog = false" :dialog="dialog"></modal>
  </v-card>
</template>

<script>
import Modal from "./Modal";
export default {
  components: {
    Modal
  },
  computed: {
    initials() {
      if (this.user.firstName && this.user.lastName) {
        return (
          this.user.firstName.charAt(0) + "" + this.user.lastName.charAt(0)
        );
      } else {
        return "NA";
      }
    }
  },
  props: ["user"],
  data: () => ({
    dialog: false
  })
};
</script>

<style scoped>
.custom-avatar {
  width: 128px !important;
  height: 128px !important;
  border-radius: 50% !important;
  border: 5px solid white !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}
</style>
